import { useNavigate } from 'react-router-dom';
import { Maximize2, Crosshair, MapPin } from 'lucide-react';
import Hub3DMap from './Hub3DMap';
import { GOOGLE_MAPS_API_KEY } from '../../lib/mapsKey';
import { Eyebrow } from '../projects/projectUi';

export const HubCard = ({ eyebrow, title, action, children, className = '', testid, bodyClass = 'p-5' }) => (
  <section className={`rounded-2xl border border-[var(--c-border)] bg-[var(--c-surface-0)] flex flex-col min-h-0 ${className}`} data-testid={testid} style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.03)' }}>
    {(eyebrow || title || action) && (
      <header className="flex items-center justify-between gap-3 px-5 pt-4 pb-3 border-b border-[var(--c-border)]">
        <div className="min-w-0">
          {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
          {title && <h2 className="text-[15px] font-semibold text-[var(--c-text)] leading-tight mt-0.5" style={{ fontFamily: 'Outfit, sans-serif' }}>{title}</h2>}
        </div>
        {action}
      </header>
    )}
    <div className={`flex-1 min-h-0 ${bodyClass}`}>{children}</div>
  </section>
);

/** Carte fenêtrée : la carte devient un composant du bento (plus de fond d'écran). */
export const HubMapCard = ({ pins, selectedId, onSelect, fitNonce, onFitAll }) => {
  const navigate = useNavigate();
  return (
    <HubCard testid="hub-map-card" bodyClass="relative" className="overflow-hidden flex-1">
      <div className="absolute inset-0">
        <Hub3DMap
          projects={pins}
          selectedId={selectedId}
          onMarkerClick={(p) => onSelect(p?.project_id || null)}
          apiKey={GOOGLE_MAPS_API_KEY}
          fitAllNonce={fitNonce}
          onNavigateDetails={(p) => navigate(`/projects/${p.project_id}`)}
          onNavigateMinisite={(p) => navigate(`/hub/viewer/${p.project_id}`)}
        />
      </div>
      <div className="absolute top-3 left-3 z-[500] flex items-center gap-2 pointer-events-none">
        <span className="inline-flex items-center gap-1.5 h-8 px-3 rounded-lg bg-white/90 backdrop-blur border border-[var(--c-border)] text-[11px] font-semibold text-[#18181B] shadow-sm pointer-events-auto">
          <MapPin className="w-3.5 h-3.5 text-[var(--c-gold)]" />{pins.length} projet{pins.length > 1 ? 's' : ''} géolocalisé{pins.length > 1 ? 's' : ''}
        </span>
      </div>
      <div className="absolute top-3 right-3 z-[500] flex items-center gap-1.5">
        <button type="button" onClick={onFitAll} title="Vue d'ensemble" aria-label="Vue d'ensemble" data-testid="hub-map-fit-btn" className="w-8 h-8 rounded-lg bg-white/90 backdrop-blur border border-[var(--c-border)] text-[#18181B] hover:bg-white flex items-center justify-center shadow-sm transition-colors">
          <Crosshair className="w-3.5 h-3.5" />
        </button>
        <button type="button" onClick={() => navigate('/hub/carte')} title="Carte plein écran (cockpit géodonnées)" data-testid="hub-map-fullscreen-btn" className="inline-flex items-center gap-1.5 h-8 px-3 rounded-lg bg-white/90 backdrop-blur border border-[var(--c-border)] text-[11px] font-semibold text-[#18181B] hover:bg-white shadow-sm transition-colors">
          <Maximize2 className="w-3.5 h-3.5" />Plein écran
        </button>
      </div>
    </HubCard>
  );
};
